import { Configurator } from "./Configurator";

class Store {

  constructor(private configurator) {
  }

  public getConfigurator() {
    return this.configurator;
  }

}

export default new Store(Configurator);
